<div class="login-box">
  <div class="lottie-animation m-b-32">
    <ng-lottie [options]="options"></ng-lottie>
  </div>
  <h2 class="auth-m-title" *ngIf="!errorMessage">
    {{ "ACCOUNT_VERIFIED" | translate }}
  </h2>
  <h2 class="auth-m-title" *ngIf="errorMessage">
    {{ "INVALID_TOKEN" | translate }}
  </h2>
  <p class="login-desc m-b-32">{{ "WELCOME_TASKOPAD" | translate }}</p>
  <button
    type="submit"
    class="btn blue-gredient-btn form-control w-100 justify-content-center"
    mat-button
    mat-flat-button
    routerLink="/"
  >
    {{ "GO_BACK_TO_LOGIN" | translate }}
  </button>
</div>
